import type { Ref } from "vue";
import type { gpedPedidosPaginacionFilterParams } from "../interfaces/gpedPedidosPaginacionFilterParams";

export function defaultSortOrderForField(field: string): "asc" | "desc" {
  if (field === "metodoPago" || field === "estadoPedido") return "asc";
  return "desc";
}

export function applyPedidosSortField(
  params: Ref<gpedPedidosPaginacionFilterParams>,
  field: string
) {
  const p = params.value;
  if (p.sortBy === field) {
    p.sortOrder = p.sortOrder === "asc" ? "desc" : "asc";
  } else {
    p.sortBy = field;
    p.sortOrder = defaultSortOrderForField(field);
  }
  p.page = 1;
}
